
export default function Features() {
  const features = [
    {
      icon: 'ri-syringe-line',
      title: 'IV Sedation',
      description: 'We offer professional IV sedation to help you feel completely relaxed and comfortable during your treatment, ensuring a stress-free experience.'
    },
    {
      icon: 'ri-user-heart-line',
      title: 'Compassionate Care',
      description: 'Our team takes time to listen to your concerns and works at your pace, ensuring you feel comfortable and in control throughout.'
    },
    {
      icon: 'ri-time-line',
      title: 'Flexible Scheduling',
      description: 'We offer extended hours and priority appointments for anxious patients, making it easier to fit dental care into your life.'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Pain-Free Techniques',
      description: 'Using the latest technology and gentle techniques, we ensure your treatment is as comfortable and pain-free as possible.'
    },
    {
      icon: 'ri-home-heart-line',
      title: 'Calming Environment',
      description: 'Our practice is designed with your comfort in mind, featuring soothing colours, comfortable seating, and a peaceful atmosphere.'
    },
    {
      icon: 'ri-chat-smile-3-line',
      title: 'Clear Communication',
      description: 'We explain every step of your treatment in simple terms, so you always know what to expect and feel fully informed.'
    }
  ];

  return (
    <section id="features" className="relative py-16 sm:py-20 md:py-24 px-4 sm:px-6 overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://static.readdy.ai/image/0a3008c36638439fa5d134c9c6a19be7/eb46ec39108bcebc22189604042184c8.jpeg"
          alt="Beaulieu Dental Chelmsford - Comfortable dental treatment room"
          title="Beaulieu Dental - Modern and comfortable dental care environment"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/60 to-black/70"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <div className="inline-block bg-[#d0a24f]/20 rounded-full px-4 sm:px-6 py-2 mb-4">
            <span className="text-[#d0a24f] text-sm font-semibold whitespace-nowrap">Why Choose Us</span>
          </div>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-6 px-4">
            Designed for Your Comfort
          </h2>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {features.map((feature, index) => (
            <div 
              key={index}
              className="group bg-white/10 backdrop-blur-md rounded-3xl p-6 md:p-8 hover:bg-white/20 hover:shadow-2xl transition-all duration-300 border border-white/20"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center bg-[#d0a24f]/20 rounded-2xl mb-4 md:mb-6 group-hover:bg-[#d0a24f] transition-colors">
                <i className={`${feature.icon} text-xl md:text-2xl text-[#d0a24f] group-hover:text-white transition-colors`}></i>
              </div>
              <h3 className="text-lg md:text-xl font-bold text-white mb-2 md:mb-3">
                {feature.title}
              </h3>
              <p className="text-sm md:text-base text-white/80 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}